import { Injectable } from '@angular/core'
import { catchError } from 'rxjs/operators'
import { HttpUtil } from 'src/service/common.http'
import { HandleError, HttpErrorHandler } from 'src/service/http-error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private http: HttpUtil, private httpErrorHandler: HttpErrorHandler) {
    this.handleError = httpErrorHandler.createHandleError('StoreService')
  }

  private handleError: HandleError
  private urlConfig = {
    user: (id: number) => `/a/7moor/user/${id}`,
    order: {
      list: '/a/7moor/user/orders/search',
    },
    coupon: {
      search: '/a/7moor/coupon/search',
      issue: (id: number) => `/a/7moor/coupon/issue/${id}`,
    },
    express: (id: number) => `/a/7moor/userExpress/${id}`,
    remark:(id:number)=>`/a/7moor/customerUser/${id}`
  }
  login(params) {
    return this.http
      .post('/a/customerService/login', params)
      .pipe(catchError(this.handleError('login')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

  getUser(id, params): Promise<any> {
    params.token = localStorage.getItem('token') || ''
    params.merchantId = localStorage.getItem('merchantId') || ''
    return this.http
      .get(this.urlConfig.user(id), { params })
      .pipe(catchError(this.handleError('getUser')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

  getOrderList(params: any): Promise<any> {
    params.token = localStorage.getItem('token') || ''
    params.merchantId = localStorage.getItem('merchantId') || ''
    return this.http
      .get(this.urlConfig.order.list, { params })
      .pipe(catchError(this.handleError('getOrderList')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }
  getCouponList(params: any): Promise<any> {
    params.merchantId = localStorage.getItem('merchantId') || ''
    params.token = localStorage.getItem('token') || ''
    return this.http
      .get(this.urlConfig.coupon.search, { params })
      .pipe(catchError(this.handleError('getCouponList')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

  sendIssue(params) {
    return this.http
      .post(this.urlConfig.coupon.issue(params.id), params)
      .pipe(catchError(this.handleError('sendIssue')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

  getExpress(id: number) {
    return this.http
      .get(this.urlConfig.express(id))
      .pipe(catchError(this.handleError('getExpress')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

  updateRemark(params) {
    const {id} = params
    return this.http
      .put(this.urlConfig.remark(id),params)
      .pipe(catchError(this.handleError('updateRemark')))
      .toPromise()
      .then((res: any) => (res.code === 0 ? res : Promise.reject(res)))
  }

}
